import { getLanguages, getTranslate, getActiveLanguage } from 'react-localize-redux'

export const selectTranslate = state => getTranslate(state.locale)
export const selectLanguages = state => getLanguages(state.locale)
export const selectCurrentLanguage = state => getActiveLanguage(state.locale).code
